<template>
    <div class="home-page text-pages privacy-page umowa-page">
        <div class="container" v-if="umowa">
            <div v-html="umowa.text"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'umowa',
    data: function() {
      return {
          umowa: ''
      }
  },

  watch: {
      lang() {
    }
  },
  created() {
      this.$http.get('ajax/pages/umowa')
          .then(response => {
              return response.json();
          })
          .then(response => {
              // Сохранение полученных данных в переменную privacy
              this.umowa = response.data;
          })
          .catch(err => {
              this.httpHandler(err);
          });
  },
  methods:{

  },
  computed: {
      languages() {
          return this.$store.state.language.list;
      },

  },
  mounted() {

  },
  components: {

  }
}
</script>
